import React from 'react';

interface SearchLightProps {
  className?: string;
  width?: number;
  height?: number;
}

const SearchLightIcon = function SearchLightIcon({
  className,
  width,
  height,
}: SearchLightProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <g filter="url(#filter0_d_1059_8167)">
        <circle cx="12" cy="9" r="8" fill="transparent" />
        <circle cx="12" cy="9" r="7.5" stroke="#9D9D9D" fill="transparent" />
      </g>
      <g filter="url(#filter1_d_1059_8167)">
        <path d="M25 22L17 14" stroke="#9D9D9D" />
      </g>
      <defs>
        <filter id="filter0_d_1059_8167" x="0" y="1" width="24" height="24" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.9375 0 0 0 0 0.9375 0 0 0 0 0.9375 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1059_8167" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1059_8167" result="shape" />
        </filter>
        <filter id="filter1_d_1059_8167" x="12.6465" y="13.6445" width="16.707" height="16.7109" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.9375 0 0 0 0 0.9375 0 0 0 0 0.9375 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1059_8167" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1059_8167" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

SearchLightIcon.defaultProps = {
  className: '',
  width: 24,
  height: 24,
};

export default SearchLightIcon;
